import AutocaptureConfig from "../../../../contents/docs/libraries/ios/_snippets/autocapture-config-ios.mdx";
import * as React from 'react';
export default {
  AutocaptureConfig,
  React
};